const TRUE_VALUES = new Set(["true", "1", "yes", "y", "on", "enabled", "enable"]);
const FALSE_VALUES = new Set(["false", "0", "no", "n", "off", "disabled", "disable"]);

const normalizeBoolean = (value) => {
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value === 1;
  if (value === null || value === undefined || value === "") return undefined;

  const normalized = String(value).trim().toLowerCase();
  if (TRUE_VALUES.has(normalized)) return true;
  if (FALSE_VALUES.has(normalized)) return false;
  return undefined;
};

const pickText = (source = {}, keys = []) => {
  for (const key of keys) {
    const value = source?.[key];
    if (typeof value === "string" && value.trim()) return value.trim();
  }
  return "";
};

const normalizeTelegramUrl = (value = "") => {
  const link = value.trim();
  if (!link) return "";
  if (/^(https?:)?\/\//i.test(link) || /^tg:/i.test(link)) return link;
  if (/^(t\.me|telegram\.me|telegram\.dog)\//i.test(link)) return `https://${link}`;
  return link;
};

const getTelegramSource = (settings = {}) => {
  const snsItems = [
    settings.SNS_banner_settings,
    settings.sns_banner_settings,
    settings.snsBannerSettings,
  ].find(Array.isArray);

  const snsTelegram = snsItems?.find((item) => {
    const label = String(item?.title || item?.name || item?.key || item?.type || "")
      .trim()
      .toLowerCase();
    return label === "telegram";
  });

  if (snsTelegram) return snsTelegram;
  if (settings.telegram && typeof settings.telegram === "object") return settings.telegram;
  if (settings.domainSettings?.telegram && typeof settings.domainSettings.telegram === "object") {
    return settings.domainSettings.telegram;
  }
  return {};
};

const getExplicitEnabled = (source = {}, settings = {}) => {
  const sourceValue =
    source.is_use ??
    source.isUse ??
    source.is_visible ??
    source.enabled ??
    source.use ??
    source.is_enabled;
  const sourceEnabled = normalizeBoolean(sourceValue);
  if (sourceEnabled !== undefined) return sourceEnabled;

  const settingsValue =
    settings.telegram_use ??
    settings.use_telegram ??
    settings.is_telegram_use ??
    settings.domainSettings?.telegram_use ??
    settings.domainSettings?.use_telegram;

  return normalizeBoolean(settingsValue);
};

export const getTelegramContactLink = (settings = {}) => {
  const source = getTelegramSource(settings);
  const link = normalizeTelegramUrl(
    pickText(source, ["link", "url", "href", "telegram_link", "telegram_url"]) ||
      pickText(settings, ["telegram_link", "telegram_url"]) ||
      pickText(settings.domainSettings, ["telegram_link", "telegram_url"])
  );
  if (!link) return "";

  const enabled = getExplicitEnabled(source, settings);
  return enabled === false ? "" : link;
};

export const openTelegramContact = (settings, onMissing) => {
  const link = getTelegramContactLink(settings);
  if (!link) {
    onMissing?.();
    return false;
  }

  window.open(link, "_blank", "noopener,noreferrer");
  return true;
};
